/** Absolute URL for a path on the public marketing site (apex / www). */
export function marketingSiteUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const configured = process.env['REACT_APP_MARKETING_SITE_URL']?.replace(/\/$/, '');
  if (configured) {
    return `${configured}${normalized}`;
  }
  const hosts = process.env['REACT_APP_MARKETING_HOSTS']?.split(',')[0]?.trim();
  if (hosts && hosts !== 'localhost') {
    return `https://${hosts}${normalized}`;
  }
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${normalized}`;
  }
  return normalized;
}
